import React from "react";
import getStarted from "../Assets/Images/getStarted.png";
import { RiCalendarTodoLine } from "react-icons/ri";
import { FcTodoList } from "react-icons/fc";
import { CiWallet } from "react-icons/ci";
import { MdOutlineSettingsSuggest } from "react-icons/md";
import { AiOutlineFileProtect, AiOutlineUnorderedList } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import "../Assets/css/main.css";

function GetStarted(props) {
  const { colorTheme } = props;
  let navigate = useNavigate();

  const goToLoginHandler = () => {
    window.location.pathname = "/login";
  };

  return (
    <div>
      <div id="iull" className="gjs-row">
        <div id="i7sn" className="gjs-cell">
          <div id="i5h5n">
            <p>Microloan Malaysia</p>
          </div>
        </div>
        <div id="i49d" className="gjs-cell"></div>
        <div id="io4l" className="gjs-cell">
          <div className="stellar-button-container" id="if2mt">
            <button className="stellar-btn" id="iy9xg">
              <p id="ia3it">
                <a onClick={() => goToLoginHandler()}>Get Started</a>
              </p>
            </button>
          </div>
        </div>
      </div>
      <div id="ia87e" className="gjs-row">
        <div id="ijfqc" className="gjs-cell">
          <div className="gjs-row" id="ik9kq">
            <div className="gjs-cell" id="ifm1i"></div>
            <div className="gjs-cell" id="i9way">
              <div id="iwoon">
                <h2>
                  <span style={{ fontSize: "35px", fontWeight: "bold" }}>
                    {" "}
                    Your Partner{" "}
                  </span>
                  <br />
                </h2>
                <h2>
                  <span style={{ fontSize: "35px", fontWeight: "bold" }}>
                    In your journey of success
                  </span>
                  <br />
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="gjs-row" id="irpzj">
        <div className="gjs-cell" id="ipu2h">
          <div className="gjs-row" id="i3caj">
            <div className="gjs-cell" id="itkdg">
              <div id="iws5v">
                <h2>
                  <span
                    style={{
                      color: "#000",
                      fontWeight: "bold",
                      fontSize: "30px",
                    }}>
                    Who are we?
                  </span>{" "}
                </h2>
              </div>
              <div id="iy3g2" style={{ fontSize: "18px", color: "#000" }}>
                <p>
                  Microloan Malaysia, a trailblazer in finance, offers small
                  loans with flexible repayment plans, tailoring solutions to
                  individual needs. &nbsp;Microloan isn't just about loans; it's
                  a catalyst for entrepreneurship, poverty alleviation, and
                  economic empowerment. With a focus on inclusion and women's
                  empowerment, microloan drives innovation, resilience, and
                  community development. By extending banking services to
                  underserved populations and nurturing small businesses, it
                  paves the way for sustainable prosperity, transforming lives
                  and fueling economic growth worldwide. &nbsp;
                </p>
                <p>
                  <br />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="iptaw" className="gjs-row">
        <div id="ibg7f" className="gjs-cell">
          <div id="ihh4g">
            <h2>
              <span style={{ fontSize: "30px", fontWeight: "bold" }}>
                How it works?
              </span>
            </h2>
          </div>
          <div className="gjs-row" id="idtbu">
            <div className="gjs-cell" id="i8odm">
              <div className="gjs-row" id="im761">
                <div className="gjs-cell" id="i1jdk">
                  <img id="ibgsk" src="microloanImage/file-1711702498169.png" />
                </div>
              </div>
              <div className="gjs-row" id="iv1m1">
                <div className="gjs-cell" id="ijxr5">
                  <div id="ixyni">
                    <p>&nbsp;Submit Your Application&nbsp;</p>
                  </div>
                  <div id="i62dh">
                    <p>
                      Fill out our short online application form to get started,
                      secured with 256-bit technology all from the comfort of
                      your home.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="gjs-cell" id="iotf3"></div>
            <div className="gjs-cell" id="i9mfh7">
              <div className="gjs-row" id="i7o3i">
                <div className="gjs-cell" id="i8uvk">
                  <img src="microloanImage/file-1711702508565.png" id="iwz4n" />
                </div>
              </div>
              <div className="gjs-row" id="ipo7zo">
                <div className="gjs-cell" id="i6duf5">
                  <div id="iza92">
                    <p>&nbsp;Get our Loan Approved&nbsp;</p>
                  </div>
                  <div id="i6vloc">
                    <p>
                      Application is reviewed and approved by our team, read all
                      the loan terms and provide acceptance to receive the loan
                      amount.&nbsp;
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="gjs-cell" id="i9o8g"></div>
            <div className="gjs-cell" id="itake">
              <div className="gjs-row" id="ihaxe">
                <div className="gjs-cell" id="iljhc">
                  <img src="microloanImage/file-1711702518329.png" id="iiu2x" />
                </div>
              </div>
              <div className="gjs-row" id="iia9r">
                <div className="gjs-cell" id="idoiu">
                  <div id="iyw98">
                    <p>Loan Amount Disbursal&nbsp;</p>
                  </div>
                  <div id="ix4yq">
                    <p>
                      Get the amount deposited into your bank account as soon as
                      the next business day.&nbsp;
                      <br />
                    </p>
                    <p>
                      <br />
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="gjs-cell" id="iwlkk"></div>
          </div>
        </div>
      </div>
      <div id="ingdk" className="gjs-row">
        <div id="i6wv1" className="gjs-cell">
          <div id="iatxr">
            <h2>
              <span style={{ fontSize: "30px", fontWeight: "bold" }}>
                What Do We Do?
              </span>
            </h2>
          </div>
          <div id="iei47" className="gjs-row">
            <div id="i22ui" className="gjs-cell">
              <div
                id="i10f3"
                style={{
                  fontSize: "18px",
                  color: "#000",
                }}>
                <p>
                  We understand that sometimes unexpected expenses can arise,
                  and getting the necessary funds to cover them can be
                  challenging. That's why we offer a convenient service that
                  aims to connect customers with lenders who offer loans that
                  may work for them. Our goal is to make the loan application
                  process as quick and straightforward as possible, so you can
                  get the funds you need to handle any unexpected
                  expenses.&nbsp;
                  <br />
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="gjs-cell" id="it78n">
          <img id="ixbuj" src="microloanImage/file-1711964937711.png" />
        </div>
      </div>
      <div className="gjs-row" id="ixgfa">
        <div className="gjs-cell" id="i95tb">
          <div className="gjs-row" id="i5f67">
            <div className="gjs-cell" id="iu4sh">
              <div id="ihzyf">
                <p>
                  <span style={{ color: "white" }}>
                    Our Impact on Southeast Asia
                  </span>
                </p>
              </div>
            </div>
            <div className="gjs-cell" id="ijo24">
              <div id="i7sdj" style={{ fontSize: "18px" }}>
                <p>
                  As one of the largest providers of microloans in Southeast
                  Asia, Microloan Malaysia has made a significant impact on
                  countless lives and communities. Our initiatives have not only
                  transformed individual livelihoods but have also contributed
                  to the overall economic development of the region.&nbsp;
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="igkih" className="gjs-row">
        <div id="i88i1" className="gjs-cell">
          <div id="ib3qf">
            <h2>
              <span style={{ fontSize: "30px", fontWeight: "bold" }}>
                Why Us?
              </span>
            </h2>
          </div>
          <div id="iuey9" className="gjs-row">
            <div id="iogkw" className="gjs-cell">
              <img id="iaj9g" src="microloanImage/file-1711964952132.png" />
            </div>
            <div id="i7fvj" className="gjs-cell">
              <div className="gjs-row" id="i8kwck">
                <div className="gjs-cell" id="imy9nh">
                  <img id="i2raf" src="microloanImage/file-1711702902471.png" />
                </div>
                <div className="gjs-cell" id="ilq2dp">
                  <div id="idwut">
                    <h3>
                      You may be approved even with a poor credit history&nbsp;
                    </h3>
                  </div>
                </div>
              </div>
              <div className="gjs-row" id="ipnkx">
                <div className="gjs-cell" id="i3e72">
                  <img id="ivayt" src="microloanImage/file-1711702846777.png" />
                </div>
                <div className="gjs-cell" id="is5r6">
                  <div id="i1i9v">
                    <h3>
                      Our Online form is quick, secure, &amp; hassle free&nbsp;
                    </h3>
                  </div>
                </div>
              </div>
              <div className="gjs-row" id="iih0f5">
                <div className="gjs-cell" id="ivnqj">
                  <img id="io0xq" src="microloanImage/file-1711702919839.png" />
                </div>
                <div className="gjs-cell" id="ivfj2n">
                  <div id="igerr">
                    <h3>
                      Your information is protected with 256-bit
                      technology&nbsp;
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="gjs-row" id="ium7g">
        <div id="islxp" className="gjs-cell"></div>
        <div id="ivlto" className="gjs-cell">
          <div className="stellar-button-container" id="ijqol">
            <button className="stellar-btn" id="i6tyl">
              <p id="iezg4">
                <a onClick={() => navigate("/login")}>
                  Get Your Microloan Today!
                </a>
              </p>
            </button>
          </div>
        </div>
        <div id="i0rwk" className="gjs-cell"></div>
      </div>
      <div className="gjs-row" id="i8qtb">
        <div className="gjs-cell"></div>
      </div>
    </div>
  );
}

export default GetStarted;
